import { render } from "./MasterQuestion.vue?vue&type=template&id=81737310&scoped=true&bindings={\"answers\":\"props\",\"images\":\"props\",\"questionId\":\"props\",\"questionType\":\"props\",\"state\":\"setup\",\"selectIndex\":\"setup\",\"submitAnswer\":\"setup\"}"
import script from "./MasterQuestion.vue?vue&type=script&lang=ts"
export * from "./MasterQuestion.vue?vue&type=script&lang=ts"

import "./MasterQuestion.vue?vue&type=style&index=0&id=81737310&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-81737310"

export default script